import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "novedades",
  class: "col-12 py-5 custom-novedades"
}
const _hoisted_2 = { class: "row col-12 col-md-10 col-lg-8 mx-auto justify-content-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bold text-center mb-5 px-md-3 h3" }, "NOVEDADES")
], -1)
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12 col-md-6 mb-4 d-none d-md-block" }
const _hoisted_6 = { class: "col-12 col-md-6 px-md-4 mb-4" }
const _hoisted_7 = { class: "row d-md-none" }
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-12 col-md-6 mb-4 d-none d-md-block" }
const _hoisted_11 = { class: "col-12 col-md-6 px-md-4 mb-4" }
const _hoisted_12 = { class: "fw-bold" }
const _hoisted_13 = { class: "fw-bold mb-3 small" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "ver mas", -1)
const _hoisted_16 = { class: "row d-md-none" }
const _hoisted_17 = { class: "col-12" }

import { onMounted, ref } from 'vue'
import BaseImg from './BaseImg.vue'
import { Skeletor } from 'vue-skeletor'

import useSitio from '@/composables/useSitio'
import { RouterLink } from 'vue-router'
import sleep from '@/utils/Sleep'


export default /*#__PURE__*/_defineComponent({
  __name: 'TheNovedades',
  props: {
    total: null
  },
  setup(__props: any) {

const props = __props as {
  total: number
};



const isLoading = ref(true)
const { getNovedades } = useSitio()

const novedades = ref<
  {
    actividadId: number
    nombre: string
    bajada: string
    descripcion: string
    imagen: string
    titulo: string
  }[]
>([])

// Simular carga de datos
onMounted(async () => {
  isLoading.value = true
  await sleep(1)
  const data = await getNovedades()
  novedades.value = data
  isLoading.value = false
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (isLoading.value)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(props.total, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-12 mb-5",
              key: index
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_unref(Skeletor), {
                    type: "rect",
                    width: "100%",
                    height: "280",
                    class: "rounded-3 placeholder"
                  })
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_unref(Skeletor), {
                    type: "text",
                    width: "60%",
                    height: "40px",
                    class: "small rounded-3 mb-5"
                  }),
                  _createVNode(_unref(Skeletor), {
                    type: "text",
                    width: "100%",
                    height: "80px",
                    class: "small rounded-3 mb-5"
                  }),
                  _createVNode(_unref(Skeletor), {
                    type: "text",
                    width: "10%",
                    height: "40px",
                    class: "small rounded-3 mb-1"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_unref(Skeletor), {
                    type: "rect",
                    width: "100%",
                    height: "280",
                    class: "rounded-3 placeholder"
                  })
                ])
              ])
            ]))
          }), 128))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(novedades.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-12 mb-5",
              key: index
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(BaseImg, {
                    src: item.imagen,
                    alt: item.titulo,
                    class: "img-fluid w-100 rounded-3"
                  }, null, 8, ["src", "alt"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("h4", _hoisted_12, _toDisplayString(item.nombre), 1),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(item.bajada), 1),
                  _createElementVNode("div", {
                    innerHTML: item.descripcion,
                    class: "mb-3 truncate-multiline"
                  }, null, 8, _hoisted_14),
                  _createVNode(_unref(RouterLink), {
                    to: {
                  name: 'Actividad',
                  params: { actividadId: item.actividadId }
                },
                    class: "btn btn-primary mt-3 align-self-start"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(BaseImg, {
                    src: item.imagen ?? '',
                    alt: item.titulo,
                    class: "img-fluid w-100 rounded-3"
                  }, null, 8, ["src", "alt"])
                ])
              ])
            ]))
          }), 128))
    ])
  ]))
}
}

})